import { Tabs } from '../tabs'
import { TabsEntryType, TabType, RichTextEntry } from './types'
import { VideoEmbed } from '../video-embed'
import { MediaEmbedFieldsFragment } from '@/graphql/types'

export const renderEmbeddedEntryBlock = (entry: RichTextEntry) => {
  if (entry.__typename === 'Tabs') {
    const tabEntry = entry as TabsEntryType
    const tabs = tabEntry?.tabsCollection?.items as Array<TabType>

    if (!tabs || tabs.length === 0) {
      return null
    }

    return <Tabs tabs={tabs} />
    // return <div>Tabs</div>
  }

  if (entry.__typename === 'MediaEmbed') {
    return <VideoEmbed entry={entry as MediaEmbedFieldsFragment} />
  }

  if (entry.__typename === 'Button') {
    // Button rendering is handled by template-specific rich-text renderers to avoid circular dependencies
    // The shared renderer does not render buttons to break the cycle between shared/rich-text and dynamic template
    return null
  }

  // Default of nothing else found, maybe should not render anything?
  return <p>rendering {entry.__typename} type is not implemented</p>
}
